const env = process.env.REACT_APP_ENV || "local";

const config = require(`./env.${env}.js`).default;
export default config;
